import styled from '@emotion/styled'
import { BREAKPOINTS } from 'utils/styled'

export const SGridWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1.5rem;

  @media ${BREAKPOINTS.MD.max} {
    grid-template-columns: 1fr;
    grid-gap: 1rem;
  }
`
